import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as orderActions from "../../_redux/orders/ordersActions";
import { CreateOrderPage } from "./create-order-page/CreateOrderPage";
import { OrderProducts } from "./order-products/OrderProducts";

export function NewOrderPage() {
  const { lastOrder } = useSelector(
    (state) => ({ lastOrder: state.orders.lastOrder }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(orderActions.getOpenOrder());
  }, [dispatch]);

  // control sidebar style in 'sales/orders/new' route
  useEffect(() => {
    document.body.classList.add("aside-minimize");

    return () => {
      document.body.classList.remove("aside-minimize");
    };
  }, []);

  return (
    <>
      {!lastOrder && <CreateOrderPage />}

      {lastOrder && <OrderProducts />}
    </>
  );
}
